<template>
        <v-card class="elevation-10">
            <v-card-title>
                <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <v-autocomplete
                                    v-model="cliente_id"
                                    :items="clients"
                                    label="Client"
                                    item-text="company_name"
                                    item-value="id"
                                    clearable
                            >
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs4>
                            <v-autocomplete
                                    v-model="status_id"
                                    :items="statuses"
                                    label="Statuses"
                                    item-text="name"
                                    item-value="id"
                                    clearable
                            >
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Search"
                            ></v-text-field>
                        </v-flex>
                      <v-flex xs1 sm1 d-flex>
                        <v-select
                          :items="[10, 15, 25, 35, 50 ,60]"
                          label="Per page"
                          v-model="per_page"
                          @change="getOrders"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                </v-container>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="orders.data"
                    :search="search"
                    :pagination.sync="pagination"
                    hide-actions
                    :loading="loading"
                    :total-items="8"
                    v-on:update:pagination="ordenar"
            >
                <template slot="items" slot-scope="props">
                    <tr>
                        <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)">{{ props.item.our_order_number }}</td>
                        <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs" >{{ props.item.client_name }}</td>
                        <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs">{{ props.item.status.name }}</td>
                        <td @click="ver(props.item.id, false)" @contextmenu.prevent="ver(props.item.id, true)" class="text-xs">{{ props.item.date }}</td>
                        <td class="layout px-0 align-center">
                            <v-menu
                                    transition="slide-y-transition"
                                    bottom
                                    left
                            >
                                <v-btn
                                        slot="activator"
                                        color="primary"
                                        dark
                                        fab
                                        flat
                                >
                                    <v-icon>settings</v-icon>
                                </v-btn>
                                <v-list>
                                    <v-list-tile>
                                        <v-btn flat block :href="BASE + 'order/' + props.item.id + '?download_token=' + download_token" target="_blank"><v-icon left>assignment</v-icon>Order confirmation</v-btn>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-btn flat block v-on:click="copyOrder(props.item.id)"><v-icon left>file_copy</v-icon>Copy order</v-btn>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>delete</v-icon>Delete order</v-btn>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
            <div class="text-xs-center pt-4 pb-4" v-if="orders.data">
                <v-pagination
                        v-model="page"
                        :length="last_page"
                        color="secondary"
                        circle
                        :total-visible="7"
                        @input="setPage"
                ></v-pagination>
                <p class="subtitle" @click="exportar">Showing {{ orders.meta.from }} to {{ orders.meta.to }} of {{ orders.meta.total }} entries</p>
            </div>
        </v-card>
</template>

<script>
    import { BASE } from '../../../config';

    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {sortBy: 'created_at', descending: true},
                loading: true,
                headers: [
                    {
                        text: 'Number order',
                        align: 'left',
                        sortable: true,
                        value: 'our_order_number'
                    },
                    { text: 'Client', value: 'cliente_id', sortable: true },
                    { text: 'Status', value: 'status_id', sortable: true },
                    { text: 'Date', value: 'date', sortable: true },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                orders: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                clients: null,
                statuses: null,
                cliente_id: null,
                status_id: null,
                BASE: BASE,
                download_token: null,
                sortBy: 'created_at',
                order: 'desc',
                per_page: 25,
                count: 0
            }
        },
        created: function() {
            this.setSectionTitle();
            this.getClients();
            this.getStatuses();
            this.checkUser();
            this.setQueryParams();
            this.getOrders();
            this.debouncedGetOrders = _.debounce(this.getOrders, 500);            
        },
        computed: {
            export () {
                return this.BASE + 'orders/export?status_id=' + this.status_id + '&client_id=' + this.cliente_id + '&search=' + this.search + '&sortBy=' + this.sortBy + '&order=' + this.order + '&download_token=' + this.download_token
            }
        },
        watch: {
            search: function () {
                this.loading = true;
                this.page = 1;
                this.$router.push({ query: Object.assign({}, this.$route.query, { search: this.search }) });
                this.debouncedGetOrders();
            },
            last_page: function () {
                if (this.page > this.orders.meta.last_page) {
                    this.page = 1;
                }
            },
            cliente_id: function () {
                if (this.cliente_id == undefined) {
                    this.cliente_id = null;
                }
                this.page = 1;
                this.$router.push({ query: Object.assign({}, this.$route.query, { cliente_id: this.cliente_id }) });
                this.debouncedGetOrders();
            },
            status_id: function () {
                if (this.status_id == undefined) {
                    this.status_id = null;
                }
                this.page = 1;
                this.$router.push({ query: Object.assign({}, this.$route.query, { status_id: this.status_id }) });
                this.debouncedGetOrders();
            }
        },
        methods : {
            setQueryParams() {
                if (this.$route.query.search) {
                    this.search = this.$route.query.search;
                }
                if (this.$route.query.cliente_id) {
                    this.cliente_id = parseInt(this.$route.query.cliente_id);
                }
                if (this.$route.query.status_id) {
                    this.status_id = parseInt(this.$route.query.status_id);
                }
            },
            exportar () {
                var self = this;
                setTimeout(function(){
                    self.reset();
                }, 800);
                this.count++;
                if (this.count >= 3) {
                    window.open(this.export);
                }
            },
            reset () {
                this.count = 0;
            },
            ordenar (payload) {
                this.loading = true;
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getOrders();
            },
            ver(id, blank) {
                if (blank) {
                    let route = this.$router.resolve({ name: 'admin.orders.detail', params : { id : id } });
                    window.open(route.href, '_blank');
                } else {
                    this.$router.push({ name: 'admin.orders.detail', params : { id : id } });
                }

            },
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Order confirmations list.'
                });
            },
            getStatuses () {
                this.$store.dispatch('getStatusOrders').then((res) => {
                    this.statuses = res.data.data;
                }).catch((error) => {

                });
            },
            getClients () {
                this.$store.dispatch('getClientsSelect').then((res) => {
                    this.clients = res.data;
                }).catch((error) => {

                });
            },
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteOrder', {
                            id: id
                        }).then((res) => {

                            this.getOrders();

                        }).catch((error) => {

                        });
                    }
                })
            },
            setPage (page) {
                this.page = page;
                this.getOrders();
            },
            getOrders () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        client_id: this.cliente_id,
                        status_id: this.status_id,
                        sortBy: this.sortBy,
                        order: this.order,
                        per_page: this.per_page
                    }
                };
                this.$store.dispatch('getOrders', params).then((res) => {

                    this.orders = res.data;
                    this.loading = false;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            copyOrder (id) {
                this.$store.dispatch('copyOrder', {
                    id: id
                }).then((res) => {
                    this.getOrders();
                }).catch((error) => {

                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/orders/ListComponent.vue